export default "__VITE_ASSET__Dz3qkDS___"